import React from "react";
import FlyingCurrency from "./FlyingCurrency";

interface FlyingRubiesProps {
  isAnimating: boolean;
}

export default function FlyingRubies({ isAnimating }: FlyingRubiesProps) {
  return <FlyingCurrency variant="ruby" isAnimating={isAnimating} />;
}
